export const namespace = 'searchSecurities'
